import { StringUtil } from "@mcleod/core";
import {
    ChangeEvent, DataHeader, DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent, LookupModelSearchEvent,
    LookupModelSelectionEvent
} from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { ModelDrsPayeeEquip } from "./models/ModelDrsPayeeEquip";
import { AutogenLayoutAvailableTractor } from "./autogen/AutogenLayoutAvailableTractor";

export class AvailableTractor extends AutogenLayoutAvailableTractor {

    private _contactFilter = null;

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    textboxEquipmentTypeIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.applies_to = 'L';
    }

    textboxContactOnChange(event: ChangeEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH
            && StringUtil.isEmptyString(event.newValue)) {
            this.setContact(null, null, null);
        }
    }

    textboxCarrierIdOnChange(event: ChangeEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH
            && StringUtil.isEmptyString(event.newValue)) {
            this.setContact(null, null, null);
            this.removeContactSearchListenerIfNeeded();
            this.toggleContacts(false);
        }
    }

    textboxContactOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH && event.hasSelection()) {
            const contact = event.selection;
            this.setContact(
                contact.getString('name', null),
                contact.getString('phone', null),
                contact.getString('email', null)
            );
        }
    }

    sourceAvailTractDetailAfterModeChange(event: DataSourceModeChangeEvent ) {
        this.textboxDateEntered.nextFocusable = event.newMode == DataSourceMode.SEARCH
            ? this.textboxTractorId.id
            : this.textboxCarrierId.id;
    }

    sourceAvailTractDetailAfterExecution(event: DataSourceExecutionEvent) {
        const availTractDetail = event.data;
        if (!availTractDetail.isNull('carrier_id')) {
            this.toggleContacts(true);
            this.initializeContactFilter(availTractDetail.getString('carrier_id'));
        }
        if (!availTractDetail.isNull('contact')) {
            this.activeRow.setLookupModelData('contact', {'name': availTractDetail.getString('contact')});
        }
    }

    //When we select a carrier, default the Load To City/State, Equipment, and Contact
    async textboxCarrierIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH
            && event.hasSelection()
        ) {
            const carrier = event.selection;
            if (getDispatchControlBoolean('use_load_city', false)) {
                this.activeRow.set({
                    'load_to_city': carrier?.getString('search_city_name', null),
                    'load_to_state': carrier?.getString('search_state', null)
                });
            }

            if (getDispatchControlBoolean('use_primary_eq', false)) {
                const drsPayeeEquip = await new ModelDrsPayeeEquip().searchSingle({
                    'payee_id': carrier.getString('id', null),
                    'default_trailer': 'Y'
                });
                this.activeRow.set('equipment_type_id', drsPayeeEquip?.get('equipment_type_id', null));
            }

            this.initializeContactFilter(carrier.getString('id', null));


            this.setContact(
                carrier.getString('contact.name', null),
                carrier.getString('contact.phone', null),
                carrier.getString('contact.email', null)
            );
            this.toggleContacts(true);
            this.mainDataSource.displayDataInBoundComponents();
        }
    }

    private toggleContacts(value: boolean){
        this.textboxContact.enabled = value;
        this.textboxCarrierPhone.enabled = value;
        this.textboxCarrierEmail.enabled = value;
    }

    private setContact(name: string, phone: string, email: string) {
        this.activeRow.set({
            'contact': name,
            'carrier_phone': phone,
            'carrier_email': email
        });
        if (name == null) {
            this.activeRow.setLookupModelData('contact', null);
            this.textboxContact.displayData(this.activeRow, null, 0);
        } else {
            this.activeRow.setLookupModelData('contact', {'name': name});
        }
    }

    private initializeContactFilter(carrierId: string) {
        this.removeContactSearchListenerIfNeeded();
        this._contactFilter = (event: LookupModelSearchEvent) => {
            event.filter.is_active = 'Y';
            event.filter.parent_row_type = 'P';
            event.filter.parent_row_id = carrierId;
        };
        this.textboxContact.addBeforeLookupModelSearchListener(this._contactFilter);
    }

    private removeContactSearchListenerIfNeeded() {
        if (this._contactFilter) {
            this.textboxContact.removeBeforeLookupModelSearchListener(this._contactFilter);
        }
    }
}
